import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
// import store from '../store'
// import { getToken, getLoginId } from '@/utils/auth'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 15000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {

  if (!config.params) {
    config.params = {}
  }
  // config.params.token = ''//getToken()
  // config.params.loginId ='' //getLoginId()
  // config.headers['Access-Control-Expose-Headers'] = 'X-Requested-With'
  // config.headers['Access-Control-Allow-Methods'] = 'GET,POST,OPTIONS'
  // if (store.getters.token) {
  //   config.headers['X-Token'] = ''//getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  // }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
  /**
  * code为非20000是抛错 可结合自己业务进行修改
  */
    // 放行指定响应头的资源
    if (response.headers['content-type'] === 'application/vnd.ms-excel;charset=utf-8') {
      return response
    }
    if (response.headers['content-type'] === 'application/pdf') {
      return response
    }
    const res = response.data
    if (res.code * 1 !== 200 && res.code * 1 !== 5000) {
      // res.msg = res.msg ? res.msg : (res.message ? res.message : (res.data.msg ? res.data.msg : '系统错误!'))
      // Message({
      //   // 临时处理，后端返回格式不统一，接口msg位置不同
      //   message: res.msg,
      //   type: 'error',
      //   duration: 5 * 1000
      // })

      // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // store.dispatch('FedLogOut').then(() => {
          //   location.reload()// 为了重新实例化vue-router对象 避免bug
          // })
        })
      }
      // else if(res.code === 108) {
      //   Message({
      //     message: res.msg,
      //     type: 'error',
      //     duration: 5 * 1000
      //   })
      // }
      console.log("msg=====>"+res)
      Message({
        message: res.msg,
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(response.data.data)
    } else {
      return response.data.data
    }
  },
  error => {
    console.log('err' + error)// for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
    
  }
)

export default service

// import axios from 'axios'
// import router from '@/router/routers'
// import { Notification, MessageBox } from 'element-ui'
// import store from '../store'
// import { getToken } from '@/utils/auth'
// import Config from '@/config'

// // 创建axios实例
// const service = axios.create({
//   baseURL: process.env.BASE_API, // api 的 base_url
//   timeout: Config.timeout // 请求超时时间
// })

// // request拦截器
// service.interceptors.request.use(
//   config => {
//    // config.params.token = getToken()
//     //config.params.loginId = store.getters.loginId
//     // if (getToken()) {
//     //   config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
//     // }
//     config.headers['Content-Type'] = 'application/json'
//     return config
//   },
//   error => {
//     // Do something with request error
//     console.log(error) // for debug
//     Promise.reject(error)
//   }
// )

// // response 拦截器
// service.interceptors.response.use(
//   response => {
//     const code = response.status
//     if (code < 200 || code > 300) {
//       Notification.error({
//         title: response.message
//       })
//       return Promise.reject('error')
//     } else {
//       return response.data
//     }
//   },
//   error => {
//     let code = 0
//     try {
//       code = error.response.data.status
//     } catch (e) {
//       if (error.toString().indexOf('Error: timeout') !== -1) {
//         Notification.error({
//           title: '网络请求超时',
//           duration: 2500
//         })
//         return Promise.reject(error)
//       }
//       if (error.toString().indexOf('Error: Network Error') !== -1) {
//         Notification.error({
//           title: '网络请求错误',
//           duration: 2500
//         })
//         return Promise.reject(error)
//       }
//     }
//     if (code === 401) {
//       MessageBox.confirm(
//         '登录状态已过期，您可以继续留在该页面，或者重新登录',
//         '系统提示',
//         {
//           confirmButtonText: '重新登录',
//           cancelButtonText: '取消',
//           type: 'warning'
//         }
//       ).then(() => {
//         store.dispatch('LogOut').then(() => {
//           location.reload() // 为了重新实例化vue-router对象 避免bug
//         })
//       })
//     } else if (code === 403) {
//       router.push({ path: '/401' })
//     } else {
//       const errorMsg = error.response.data.message
//       if (errorMsg !== undefined) {
//         Notification.error({
//           title: errorMsg,
//           duration: 2500
//         })
//       }
//     }
//     return Promise.reject(error)
//   }
// )
// export default service



// WEBPACK FOOTER //
// ./src/util/request.js